import {
  IHeatmapQuestionModelState,
  IHeatmapResponseValidation,
  HeatmapQuestionModelTypes,
  HeatmapSubmitResponse
} from './types'
import { IQuestionModelConstructor, QuestionType } from '../types'
import BaseQuestionModel from '../BaseQuestionModel'

const HeatmapQuestionModel: IQuestionModelConstructor<HeatmapQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<HeatmapQuestionModelTypes, IHeatmapQuestionModelState>({
    questionType: QuestionType.HEATMAP,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IHeatmapQuestionModelState) {
  return [].concat(...response) as HeatmapSubmitResponse
}

function initState(state: IHeatmapQuestionModelState): IHeatmapQuestionModelState {
  state.response = []
  return state
}

function validateResponse({
  response,
  responseValidation,
  questionSchema
}: IHeatmapQuestionModelState): IHeatmapResponseValidation {
  if (responseValidation) return responseValidation

  if (!questionSchema.entities[0]?.matrix_batches?.length)
    return {
      valid: true
    }

  if (!response.length)
    return {
      valid: false
    }
  return {
    valid: false
  }
}

export default HeatmapQuestionModel
